<template>

  <div id="dialog">
    <div class="vo-scrim" :class="{active: showing, disabled: lockout, modal: modal}" @click="showing = false"></div>

    <transition name="grow">
        
      <div v-if="showing" class="center-parent">
        <div class="dialog-box">
          <div class="header">
          <div class="item-title">{{ params.title }}</div>
            <v-btn v-if="!modal" :disabled="lockout" fab flat small class="vo-icon-button" @click="showing = false">
              <v-icon medium>mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="body" v-if="params.body">{{ params.body }}</div>
          <div class="body" v-if="params.html" v-html="params.html"></div>
          <component ref="componentRef" class="body" v-if="component" :is="component"></component>

          <div class="footer-box">
            <div class="buttons">
              <v-btn v-if="!modal" flat color="info" :disabled="lockout" @click="dismiss">{{ params.dismiss.title }}</v-btn>
              
              <v-btn flat color="primary" :loading="lockout" class="confirm" v-if="params.confirm && params.confirm.title && (params.confirm.action || params.component) " @click="confirm">{{ params.confirm.title }}</v-btn>

              <div class="clear"></div>
            </div>
          </div>

        </div>
      </div>

    </transition>    
  </div>

</template>

<script>

  export default {
    data () {
      return {
        showing: false,
        params: {
          title: '',
          body: '',
          html: '',
          component: false,
          confirm: {
            action () {
            },
            title: ''
          },
          dismiss: {
            action () {
            },
            title: ''
          },
        },
        modal: false,
        lockout: false
      }
    },
    methods: {
      showDialog (params) {
        
        params = params || {};

        if (!params.title || !(params.body || params.html || params.component)) {
          console.log('\nDialog error: Missing required params: {\n\ttitle: "Title",\n\tbody: "Body goes here!",\n\tdismiss: {\n\t\taction (),\n\t\ttitle: "Dismiss!"\n\t},\n\tconfirm: {\n\t\taction (),\n\t\ttitle: "Confirm!"\n\t}\n}');
          return;
        }

        params.dismiss = params.dismiss || {};
        if (!params.dismiss.title) params.dismiss.title = 'Cancel';
        if (!params.dismiss.action) params.dismiss.action = this.dismissDefault;

        this.component = params.component || false;
        this.modal = params.modal || false;

        this.params = params;
        this.showing = true;
      },
      close () {
        this.showing = false;
      },
      confirm () {
        this.lockout = true;

        var action;
        if      (this.params.confirm.action)  action = this.params.confirm.action;
        else if (this.params.component)       action = this.$refs.componentRef.action;

        return action()
        .then(data => {
          this.lockout = false;
          this.close();
        })
        .catch(e => {
          this.lockout = false;
          console.log('\n@@@ Dialog Action Error:', e);
        })
      },
      dismiss () {
        this.params.dismiss.action();
        this.close();
      },
      dismissDefault () {
        this.showing = false;
      }
    },
    created () {
      window.Dialog = this;
    } 
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';
  @import '../css/transitions.scss';

  #dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    
    .vo-scrim {

      &.modal {
        cursor: default;
        pointer-events: none;
      }

    }
    
    .dialog-box {

      pointer-events: auto;

      position: relative;
      width: 400px;
      margin: 0 auto;
      background: $white;

      .header {

        background: $primary;
        height: 48px;
        width: 100%;

        .item-title {
          @include fontPrimary500();
          @include title();
          @include textEllipsis();
          
          position: absolute;
          top: 14px;
          left: 14px;
          right: 60px;
          
          text-transform: uppercase;
          font-size: 16px;
          color: $white;
        }

        .vo-icon-button {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          margin: 3px;

          i {
            color: $white;
            opacity: 1;
          }
        }
      } // .header
    
      .body {
        @include scrollable();
        @include fontPrimary400();

        position: relative;
        color: $black87;
        padding: 16px 16px 24px;
        line-height: 24px;
        box-sizing: border-box;
        max-height: 300px;
      }
      
      .footer-box {
        width: 100%;
        border-top: $borderBlack12;

        .buttons {
          float: right;

          .button-item {
            @include fontPrimary500();
            @include title();

            float: left;
            cursor: pointer;
            padding:20px 16px;
            user-select: none;


            &.confirm {
              color: $primary;              
            }
            &.dismiss {
              color: $black54;              
            }
            
          }
        }
      }
    }

    @media screen and (max-width: 700px) {

      .dialog-box {
        min-width: 120px;
        width: calc(100% - 32px);
      }
  
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/Dialog.vue